























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ChoiceIdentifier, SurveyChoice } from 'frontend/types/nux';

@Component({
  components: {},
  computed: {},
})
export default class NuxStepSurvey extends Vue {
  @Prop() title!: string;
  @Prop() choices!: SurveyChoice[];
  @Prop() currentSelection!: Set<ChoiceIdentifier>;

  chosen(identifier: ChoiceIdentifier): void {
    this.$emit('chosen', identifier);
  }

  selected(identifier: ChoiceIdentifier): boolean {
    return this.currentSelection.has(identifier);
  }
}
